import serviceBase from '../../../../Services/serviceBase'

class DepartmentInfoActions {
  getDepartmentInfo = async (legacyId, setDepartmentEntity) => {
    let url = `${
      window._env_.COMMUNITY_API_URL
    }/fire-departments/department-by-id`
    serviceBase.get(url).then(
      (response) => {
        setDepartmentEntity(response.data)
      },
      (err) => {
      }
    )
  }

  getLayout = async (legacyId) => {
    let url = `${
      window._env_.COMMUNITY_API_URL
    }/content-management/${legacyId}`
    return serviceBase.get(url).then(
      (response) => {
        return response
      },
      (err) => {
      }
    )
  }

  getShowUsage = async (departmentId) =>{
    let url = `${
      window._env_.COMMUNITY_API_URL
    }/show-usage/${departmentId}`
    return serviceBase.get(url).then(
      (response) => {
        return response
      },
      (err) => {
        console.error('Error getting show usage',err)
      }
    )
  }
}

export default new DepartmentInfoActions()
